<template>
  <div>
    <div class="details-banner" :style="{ backgroundImage: 'url(' + showInfo.schemeBackground + ')' }">
      <div class="details-intro">
        <el-row :gutter="30">
          <el-col :span="24">
            <div class="title">{{ showInfo.principleTitle }}</div>
          </el-col>
          <el-col :xs="24" :md="16" :lg="24">
            <div class="subtitle" v-html="showInfo.principleContent"></div>
          </el-col>
          <el-col :xs="24" :lg="4">
            <div class="btn" @click="() => { open = true; title = showInfo.principleTitle }">立即咨询</div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="details-container">
      <div style="width: 100%;" v-for="v in showInfo.infoList" :key="v.id">
        <div v-if="v.moduleName === '合作招募' && v.moduleStatus === '1'" align="center" class="contant-info">
          <div class="contant-title">{{ v.moduleTitle }}</div>
          <div class="recruit">
            <div v-for="item in v.contentList" :key="item.id" class="recruit-info">
              <div class="cecruit-title">
                {{ item.subtitle }}
              </div>
              <div class="cecruit-content">
                {{ item.introduction }}
              </div>
            </div>
          </div>
        </div>
        <div class="contant-gray-bg" v-if="v.moduleName === '自定义模块' && v.moduleStatus === '1'">
          <div align="center" class="contant-info bg-gray" v-for="item in v.contentList" :key="item.id"
            v-if="item.type">
            <div class="contant-title" v-if="item.type === 'subtitle'">{{ item.subtitle }}</div>
            <div class="text" v-if="item.type === 'introduction'">{{ item.introduction }}</div>
            <div align="center" v-if="item.type === 'picture'">
              <img class="gt-img" :src="item.picture" />
            </div>
            <div align="center">
              <video id="" muted loop controls preload="auto" style=" height: auto;" v-if="item.type === 'video'"
                class="gt-img">
                <source type="video/mp4" :src="item.video" />
              </video>
            </div>

          </div>
        </div>
      </div>

    </div>

    <consult v-if="open" :dialogVisible="open" @cancel="cancle" :productName="title"  productId="0"></consult>
  </div>
</template>

<script>

import { detailCoBuilding, detailPromotion } from '@/api'
export default {
  name: "SolutionDetails",
  data () {
    return {
      open: false,
      active: 1,
      showInfo: {
        title: "",
        subtitle: "",
      },
      bg: "",

      name: "",
      title: ''
    };
  },
  created () {
    this.name = this.$route.query.name;
    this.getList();
  },
  methods: {
    async getList () {
      if (this.name == "coBuilding") {
        const res = await detailCoBuilding()
        this.active = 1;
        this.showInfo = res.data

      } else {
        const res = await detailPromotion()
        this.showInfo = res.data
        this.active = 2;
      }
    },
    cancle (data) {
      this.open = data;
    },
    go (val) {
      if (val === 'back') {
        this.$router.push({ path: '/EcoPartner' });
        return
      }
      val == 'coBuilding' ? this.active = 1 : this.active = 2;
      this.name = val;
      this.getList();
    },
  },
  watch: {
    "$route.query.name" (val) {
      this.name = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.text {
  font-size: 16px;
  font-weight: 500;
  color: rgba(19, 20, 21, 0.70);
  line-height: 32px;
  text-align: left;
  padding: 0 2rem;
}

.details-banner {
  width: 100%;
  height: 420px;
  position: relative;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-color: #eaebeb;

  .details-intro {
    width: 75%;
    position: absolute;
    top: 30%;
    left: 12%;
    color: #333;

    .title {
      font-size: 36px;
      font-weight: 500;
      margin-bottom: 15px;
    }

    .subtitle {
      opacity: 0.8;
      font-size: 16px;
      font-weight: 400;
      line-height: 28px;
      width: 60%;
      max-height: 112px;
      overflow: hidden;
      text-overflow: ellipsis; //超出文本设置为...
      display: -webkit-box; //将div1转换为盒子模型
      -webkit-line-clamp: 4; //设置div1的文本为2行
      -webkit-box-orient: vertical; //从顶部向底部垂直布置子元素
    }

    .btn {
      margin-top: 34px;
      width: 120px;
      height: 35px;
      font-size: 14px;
      line-height: 35px;
      background: #e50009;
      text-align: center;
      color: #fff;
      cursor: pointer;
    }
  }
}

.details-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 50px;
  width: 100%;
  min-height: 340px;

  .contant-title {
    width: 100%;
    font-size: 32px;
    margin: 50px 0;
    font-weight: 500;
    text-align: center;
    color: #000000;
  }

  .gt-img {
    display: block;
    width: 80%;
    padding-bottom: 50px;
  }
}

.contant-info {

  &:last-child {
    padding-bottom: 50px;
  }

  .recruit {
    width: 70%;
    display: flex;
    justify-content: space-between;
    text-align: center;
  }

  .recruit-info {
    width: 30%;
  }

  .cecruit-title {
    height: 30px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 30px;
  }

  .cecruit-content {
    height: 60px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(19, 20, 21, 0.6);
    line-height: 30px;
    overflow: hidden;
    text-overflow: -o-ellipsis-lastline;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

.contant-gray-bg {
  width: 100%;
  /* background: #f9f9f9; */
  padding: 30px;
  box-sizing: border-box;
}

.product-head {
  padding-left: 12.5%;
}

.about-head {
  width: 75%;
  margin-top: 50px;

  .about-head-title {
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    cursor: pointer;
  }

  .active {
    color: #E50009;
  }
}

@media screen and (max-width: 400px) {
  .product-head {
    display: block !important;
  }

  .contant-info {
    .recruit {
      display: block;
    }

    .recruit-info {
      width: 100%;
      margin-bottom: 30px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EcosystemJoint.vue